<template>
    <div class="bg-white flex items-center md:flex-row p-3 mb-5 rounded gap-20 md:gap-5">
        <router-link :to="{ name: 'myBusinessAccounts' }" class="nav-link relative h-max text-base font-medium cursor-pointer">
            {{ $t('nav.verifiedPublications') }}

        </router-link>
        <router-link :to="{ name: 'myBusinessAccountsRequests' }"
            class="nav-link relative h-max text-base font-medium cursor-pointer text-main-color md:mb-0 md:mr-3">
            {{ $t('nav.unverifiedPublications') }}
        </router-link>
    </div>
</template>
<script>
export default {
    name: "MyBusinessAccountsNav",
   
}
</script>
<style scoped>
.router-link-exact-active{
    border-bottom: 1px solid #409DBA;
    color: #000000;
}
</style>